import React from 'react';
import VideoCategoryPage from '../components/VideoCategoryPage';

function ChaupalVideos() {
  return (
    <VideoCategoryPage
      category="chaupal"
      badge="Village Voices"
      title="चौपाल विडियोज़"
      subtitle="गाँव की आवाज़, गाँव की कहानी अब बेहतर playback अनुभव के साथ"
      description="रिपोर्ट, लोक मुद्दे और ज़मीनी बातचीत वाली वीडियो को एक warm editorial layout में लगातार देखें।"
      emptyMessage="चौपाल सेक्शन के लिए वीडियो अपडेट होते ही यहां दिखाई देंगे।"
      accentClass="video-page-chaupal"
    />
  );
}

export default ChaupalVideos;
